import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthProvider';
import ProtectedRoute from './components/ProtectedRoute';

// Pages
import LoginPage from './pages/LoginPage';
import StudentDashboard from './pages/StudentDashboard';
import AdminDashboard from './pages/AdminDashboard';
import StartupProfile from './pages/StartupProfile';
import FormBuilder from './pages/FormBuilder';
import FormSubmission from './pages/FormSubmission';
import Scoreboard from './pages/Scoreboard';
import NotFoundPage from './pages/NotFoundPage';
import AdminLayout from './pages/AdminLayout';
import StartupsPage from './pages/Startup/StartupListing';
import NewStartupPage from './pages/Startup/CreateStartup';
import StartupDetailPage from './pages/Startup/StartupDetail';
import CompetitionForm from './pages/Startup/CompetitionForm';
import CompetitionListing from './pages/Startup/CompetitionTable';
import CreateFormFromJSON from './pages/CreateFormFromJSON';
import UsersListPage from './pages/UserListPage';
import MyStartupPage from './pages/Startup/MyStartup';
import StartupDashboard from './pages/Startup/StartupDashboard';
// import UserManagementPage from './pages/';

function App() {
    return (
        <AuthProvider>
            <Router>
                <Routes>
                    {/* ===== PUBLIC ROUTES ===== */}
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/" element={<StudentDashboard />} />

                    {/* ===== STUDENT ROUTES ===== */}
                    {/* <Route
                        path="/"
                        element={
                            <ProtectedRoute>
                                <StudentDashboard />
                            </ProtectedRoute>
                        }
                    /> */}

                    <Route
                        path="/student/dashboard"
                        element={
                            <ProtectedRoute>
                                <StudentDashboard />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/profile"
                        element={
                            <ProtectedRoute>
                                <StartupProfile />
                            </ProtectedRoute>
                        }
                    />

                    {/* Form Submission - Student submits forms */}
                    <Route
                        path="/form/:formId"
                        element={
                            <ProtectedRoute>
                                <FormSubmission />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/form-submission/:formId"
                        element={
                            <ProtectedRoute>
                                <FormSubmission />
                            </ProtectedRoute>
                        }
                    />

                    {/* ===== ADMIN ROUTES ===== */}
                    <Route
                        path="/admin"
                        element={
                            <ProtectedRoute requiredRole="admin">
                                <AdminDashboard />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/admin/dashboard"
                        element={
                            <ProtectedRoute requiredRole="admin">
                                <AdminDashboard />
                            </ProtectedRoute>
                        }
                    />

                    {/* Form Builder - ALL NESTED ROUTES */}
                    {/* ✅ KEY FIX: Added /* for nested routing */}
                    <Route
                        path="/form-builder/*"
                        element={
                            <AdminLayout title="Form Management">
                                <FormBuilder />
                            </AdminLayout>
                        }
                    />
                    <Route path="/form-builder/json" element={<CreateFormFromJSON />} />


                    {/* Scoreboard */}
                    <Route
                        path="/scoreboard"
                        element={
                            <ProtectedRoute requiredRole="admin">
                                <AdminLayout title="Scoreboard & Response Sheet">
                                    <Scoreboard />
                                </AdminLayout>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/admin/scoreboard"
                        element={
                            <ProtectedRoute requiredRole="admin">
                                <Scoreboard />
                            </ProtectedRoute>
                        }
                    />
                    <Route path="/startups" element={<StartupsPage />} />

                    <Route path="/startups/new" element={<NewStartupPage />} />
                    <Route path="/startups/:startupId" element={<StartupDetailPage />} />
                    <Route path="/users" element={<UsersListPage />} />

                    <Route
                        path="/competitions"
                        element={
                            <ProtectedRoute requiredRole="admin">
                                <CompetitionListing />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/competitions/new"
                        element={
                            <ProtectedRoute requiredRole="admin">
                                <CompetitionForm />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/competitions/edit/:compId"
                        element={
                            <ProtectedRoute requiredRole="admin">
                                <CompetitionForm />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/competitions/:compId"
                        element={
                            <ProtectedRoute requiredRole="admin">
                                <CompetitionForm />
                            </ProtectedRoute>
                        }
                    />
                    <Route path="/mystartup/profile" element={
                        <ProtectedRoute allowedRoles={['startup']}>
                            <MyStartupPage />
                        </ProtectedRoute>
                    } />

                    {/* ===== CATCH-ALL & 404 ===== */}
                    <Route path="/404" element={<NotFoundPage />} />
                    <Route path="*" element={<NotFoundPage />} />
                </Routes>
            </Router>
        </AuthProvider>
    );
}

export default App;
